<template>
  <el-date-picker
    v-model="date"
    type="daterange"
    @change="handleChange"
    value-format="yyyy-MM-dd"
    format="yyyy-MM-dd"
    range-separator="至"
    :size="size"
    :clearable="!closeclearable"
    :picker-options="allDate ? '' : pickerOptions1"
    :start-placeholder="value[0] || '开始时间'"
    :end-placeholder="value[1] || '结束时间'">
  </el-date-picker>
</template>
<script>
import Config from '@/conf/index'
export default {
  name: 'MiniDatesPicker',
  props: [
    'value',
    'size',
    'allDate',
    'closeclearable'
  ],
  data () {
    return {
      date: [],
      pickerOptions1: {
        disabledDate (time) {
          // if (time.getTime() > Date.now() || time.getTime() < (Date.now() - 3600 * 1000 * 24 * 365)) {
          //   return false
          // } else {
          //   return true
          // }
          // return time.getTime() > Date.now() || time.getTime() < (Date.now() - 3600 * 1000 * 24 * 365)
          return time.getTime() > Date.now()
        }
      }
    }
  },
  watch: {
    'value': {
      handler (oldValue, newValue) {
        this.date = this.value
      },
      deep: true
    }
  },
  methods: {
    handleChange () {
      if (new Date(this.date[1]).getTime() - new Date(this.date[0]).getTime() > 3600 * 1000 * 24 * Config.dateRange) {
        this.date = this.value
        this.$message.error('仅支持选取' + Config.dateRange + '天的日期区间！')
      } else {
        this.$emit('input', this.date || [])
      }
    }
  },
  mounted () {
    this.date = this.value
  }
}
</script>
